import { render, staticRenderFns } from "./PhysioCategoryManage.vue?vue&type=template&id=2bdf754f&scoped=true"
import script from "./PhysioCategoryManage.vue?vue&type=script&lang=js"
export * from "./PhysioCategoryManage.vue?vue&type=script&lang=js"
import style0 from "./PhysioCategoryManage.vue?vue&type=style&index=0&id=2bdf754f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf754f",
  null
  
)

export default component.exports